module.exports = __webpack_public_path__ + "static/media/LOGO_white.59692385.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainNavigation/LOGO_white.svg
// module id = 599
// module chunks = 0